import { HiStar } from "react-icons/hi";
import React from "react";
import { BiCrown } from "react-icons/bi";

export const ADVANTAGES = [
  {
    title: "Renovação de Contratos",
    description: "97%",
    icon: <BiCrown />,
    color: "hsla(54, 98%, 62%, 1)",
    coordinates: {
      x: "-48px",
      y: "82%",
    },
  },
  {
    title: "Avaliações positivas ",
    description: "+2.000%",
    icon: <HiStar />,
    color: "hsla(17, 70%, 79%, 1)",
    coordinates: {
      x: "76%",
      y: "5%",
    },
  },
];
